import { render, staticRenderFns } from "./AccountInvoiceitem.vue?vue&type=template&id=42368460&"
import script from "./AccountInvoiceitem.vue?vue&type=script&lang=js&"
export * from "./AccountInvoiceitem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports